<template>
	<div id="npp-orders-app" class="orders">
		<form @submit.prevent="search" class="orders-form" v-bind:class="{ 'orders-form-nurse': user_role === 'npp_nurse' }">
			<div class="orders-form-search">
				<label id="orders-form-search-label" for="orders-form-search">Search<span aria-hidden="true">...</span></label>
				<input id="orders-form-search" v-model="searchQuery" type="text">
				<input type="submit" value="Submit Search">
			</div>
			<div>
				<label for="orders-form-facility"><span class="screen-reader-text">Filter by Facility</span></label>
				<select id="orders-form-facility" v-model="selectedFacilityTerm" @change="search">
					<option value="" aria-label="All">- Filter by Facility -</option>
					<option v-for="facility in facilities" :value="facility.value">{{ facility.name }}</option>
				</select>
			</div>
			<div>
				<label for="orders-form-service"><span class="screen-reader-text">Filter by Service</span></label>
				<select id="orders-form-service" v-model="selectedService" @change="search">
					<option value="" aria-label="All">- Filter by Service -</option>
					<option v-for="service in services" :value="service">{{ service }}</option>
				</select>
			</div>
			<div v-if="user_role === 'npp_requester'">
				<label for="orders-form-requester"><span class="screen-reader-text" aria-label="All">Filter by Requester</span></label>
				<select id="orders-form-requester" v-model="selectedRequester" @change="search">
					<option value="">- Filter by Requester -</option>
					<option v-for="requester in requesters" :value="requester.value">{{ requester.name }}</option>
				</select>
			</div>
			<!-- <button class="orders-form-reset" :disabled="!filtersChanged" @click="resetFilters">Reset All</button> -->
			<button class="orders-form-reset" @click="resetFilters">Reset All</button>
		</form>

		<button
			class="orders-more-filters" 
			@click="toggleFilterPanel"
			aria-haspopup="dialog"
			ref="filterPanelOpen"
			aria-label="Open Filters Modal"
		>
			 
			<img 
			:src="require(`@/images/icon-filter-dropdown.svg`)"
			class="orders-more-filters-icon"
			alt="filder dropdown"
			>

			More Filters
		</button>

		<transition name="filter-panel-slide">
			<div 
				class="filter-panel" 
				:class="[filterPanelVisible ? 'slide-in' : '', !filterPanelVisible ? 'slide-out' : '']" v-if="filterPanelVisible"
				role="dialog"
				aria-modal="true"
				ref="modal"
				tabindex="0"
				aria-label="Filters Modal"
				@keydown.tab="trapFocus"
			>
				<button 
					ref="close"
					class="filter-panel-close"
					@click="closeFilterPanel"
					aria-label="Close Filter Modal"
				>
					<img :src="imageModalClose" alt=""  aria-hidden="true">
				</button>
				<h2 class="order-edit-title">Filters</h2>
				<form @submit.prevent="search" class="orders-form" v-bind:class="{ 'orders-form-nurse': user_role === 'npp_nurse' }">
					<div class="orders-form-search">
						<label id="orders-form-search-label" for="orders-form-search">Search<span aria-hidden="true">...</span></label>
						<input id="orders-form-search" v-model="searchQuery" type="text">
						<input type="submit" value="Submit Search">
					</div>
					<div>
						<label for="orders-form-facility">Facility</label>
						<select id="orders-form-facility" v-model="selectedFacilityTerm" @change="search">
							<option value="" aria-label="All">- Filter by Facility -</option>
							<option v-for="facility in facilities" :value="facility.value">{{ facility.name }}</option>
						</select>
					</div>
					<div>
						<label for="orders-form-service">Service</label>
						<select id="orders-form-service" v-model="selectedService" @change="search">
							<option value="" aria-label="All">- Filter by Service -</option>
							<option v-for="service in services" :value="service">{{ service }}</option>
						</select>
					</div>
					<div v-if="user_role === 'npp_requester'">
						<label for="orders-form-requester">Requester</label>
						<select id="orders-form-requester" v-model="selectedRequester" @change="search">
							<option value="">- Filter by Requester -</option>
							<option v-for="requester in requesters" :value="requester.value">{{ requester.name }}</option>
						</select>
					</div>
					<!-- <button class="orders-form-reset" :disabled="!filtersChanged" @click="resetFilters">Reset All</button> -->
					<button class="close-button button" @click="closeFilterPanel">Apply Filters</button>
					<button class="orders-filter-reset" @click="resetFilters">Reset All</button>
				</form>
			</div>
		</transition>

		<div class="orders-controls">
			<div class="orders-status-filters">
				<button 
					v-if="user_role === 'npp_requester'"
					@click="filterByStatus('')"
					:aria-pressed="selectedStatusTerm === '' ? 'true' : 'false'"
				>
					All<span>{{ statusCounts.all }}</span>
				</button>
				<button
					@click="applyFilterByAuthor"
					:aria-pressed="filterByAuthor.toString()"
				>
					Mine<span>{{ statusCounts.mine }}</span>
				</button>
				<button
					@click="filterByStatus('open')"
					:aria-pressed="selectedStatusTerm === 'open' ? 'true' : 'false'"
				>
					Open<span>{{ statusCounts.open }}</span>
				</button>
				<button 
					@click="filterByStatus('completed')"
					:aria-pressed="selectedStatusTerm === 'completed' ? 'true' : 'false'"
				>
					Completed<span>{{ statusCounts.completed }}</span>
				</button>
				<button 
					@click="filterByStatus('canceled')"
					:aria-pressed="selectedStatusTerm === 'canceled' ? 'true' : 'false'"
				>
					Canceled<span>{{ statusCounts.canceled }}</span>
				</button>
			</div>
				<div class="orders-per-page">
					<div class="mobile-results-per-page">
						<div class="orders-pagination" id="pagination-control">
				
				<span class="orders-pagination-count" aria-live="polite"> Showing <strong>{{ startItemCount }}-{{ endItemCount }} of {{ totalItems }}</strong></span>
				
			</div>
					</div>
					<label for="orders-pagination">Results per Page:</label>
					<select id="orders-pagination" v-model="selectedPostsPerPage" @change="changePostsPerPage">
						<option v-for="option in postsPerPageOptions" :value="option">
							{{ option }}
						</option>
					</select>
				</div>
		</div>

		<table v-if="posts.length">
			<caption class="screen-reader-text">Orders</caption>
			<thead>
				<tr>
					<th v-bind:aria-sort.prop="sortField === 'npp_status_date' ? sortOrder : undefined"><button @click="sortService('npp_status_date')">Status</button></th>
					<th v-bind:aria-sort.prop="sortField === 'npp_facility' ? sortOrder : undefined"><button @click="sortService('npp_facility')">Facility</button></th>
					<th v-bind:aria-sort.prop="sortField === 'npp_primary_nurse' ? sortOrder : undefined"><button @click="sortService('npp_primary_nurse')">Patient's Nurse</button></th>
					<th>Unit Phone</th>
					<th>Room #</th>
					<th v-bind:aria-sort.prop="sortField === 'npp_service' ? sortOrder : undefined"><button @click="sortService('npp_service')">Service</button></th>
					<th>Details</th>
					<th v-if="user_role === 'npp_nurse' || user_role === 'npp_manager'">Assigned To</th>
					<th>Actions</th>
				</tr>
			</thead>
			
			<tbody>
				<template v-for="(post, index) in posts" :key="post.ID">
					<tr class="order" :class="{ 'order-expanded': post.showComments }">
						<td data-label="Status" class="order-status-td">
							<div class="order-column-wrap">
								<div v-if="post.npp_status" class="order-status" :class="'order-status-' + post.npp_status">
									{{ post.npp_status }}
								</div>
								<div v-if="post.npp_status_date" class="order-status-date">
									{{ post.npp_status_date }}
								</div>
							</div>

							<div class="order-actions-mobile order-actions">
								<button
									v-if="post.npp_status === 'open'  && user_role === 'npp_requester'"
									@click="updateOrderStatus(post, 'canceled')" 
									:aria-label="`Cancel order ${post.ID}`"
								>
									<img :src="imageActionCancel" alt="" aria-hidden="true">
									<span>Cancel</span>
								</button>
								<button 
									v-if="post.npp_status === 'open' && user_role === 'npp_nurse' && ! post.acf.npp_assigned_nurse"
									@click="assignNurse(post)"
									:aria-label="`Accept order ${post.ID}`"
								>
									<img :src="imageActionAccept" alt="" aria-hidden="true">
									Accept
								</button>
								<button 
									v-if="post.npp_status === 'open' && user_role === 'npp_nurse' && post.acf && post.acf.npp_assigned_nurse && post.acf.npp_assigned_nurse.ID == user"
									:aria-label="`Complete order ${post.ID}`"
									@click="updateOrderStatus(post, 'completed')"
								>
									<img :src="imageActionComplete" alt="" aria-hidden="true">
									Complete
								</button>
								<button 
									v-if="post.npp_status === 'open' && user_role === 'npp_nurse' && post.acf && post.acf.npp_assigned_nurse &&  post.acf.npp_assigned_nurse.ID == user"
									:aria-label="`Decline order ${post.ID}`"
									@click="updateOrderStatus(post, 'open')"
								>
									<img :src="imageActionDecline" alt="" aria-hidden="true">
									Decline
								</button>

							</div>
						
						</td>
						<td data-label="Facility">{{ post.acf && post.acf.npp_facility ? post.acf.npp_facility.name : '' }}</td>
						<td data-label="Patient's Nurse">{{ post.acf ? post.acf.npp_primary_nurse : '' }}</td>
						<td data-label="Unit Phone">{{ post.acf ? post.acf.npp_unit_phone : '' }}</td>
						<td data-label="Room #">{{ post.acf ? post.acf.npp_room_number : '' }}</td>
						<td data-label="Service">{{ post.acf ? post.acf.npp_service : '' }}</td>
						<td data-label="Details">
							<div class="order-column-wrap">
								<div>
									<button class="order-comment-button" @click.prevent.stop="toggleComments(index)" :aria-pressed="selectedStatusTerm === '' ? 'true' : 'false'" :aria-controls="'comments-' + post.ID">
										{{ post.showComments ? 'Close' : 'Expand' }}
									</button>
								</div>
								<div v-if="post.acf.npp_comments" class="order-comment-label">Has Comments</div>
								
							</div>
							
						</td>

						<td v-if="post.showComments" :key="post.ID + '_comments'" :id="'comments-' + post.ID" class="order-comment-panel order-comment-panel-mobile">
							<span>
								<div v-if="post.acf.npp_comments">
									<p><strong>Comment </strong><br />{{ post.acf.npp_comments }}</p>
								</div>
								<p>
									<strong>Requested By:</strong> {{ post.post_author.display_name }} 
								</p>
								<p>
									<strong> ID:</strong> {{ post.ID }}
								</p>
							</span>
						</td>

						<td v-if="user_role === 'npp_nurse' || user_role === 'npp_manager'" data-label="Assigned To" >
							<div class="order-actions order-actions-assigned">
								<button 
									v-if="post.acf.npp_assigned_nurse" 
									:ref="`nurseModalOpenButton-${index}`"
									@click="openModal(post.acf.npp_assigned_nurse, '', index)"
									:aria-label="`view contact info for ${post.acf.npp_assigned_nurse.display_name}`"
									aria-haspopup="dialog"
								>
									{{ post.acf.npp_assigned_nurse.display_name }}
								</button>
							</div>
						</td>

						<td data-label="Actions" class="order-actions-desktop">
							<div class="order-actions">
								<button
									v-if="post.npp_status === 'open'  && user_role === 'npp_requester'"
									@click="updateOrderStatus(post, 'canceled')" 
									:aria-label="`Cancel order ${post.ID}`"
								>
									<img :src="imageActionCancel" alt="" aria-hidden="true">
									<span>Cancel</span>
								</button>
								<button 
									v-if="post.npp_status === 'open' && user_role === 'npp_nurse' && ! post.acf.npp_assigned_nurse"
									@click="assignNurse(post)"
									:aria-label="`Accept order ${post.ID}`"
								>
									<img :src="imageActionAccept" alt="" aria-hidden="true">
									Accept
								</button>
								<button 
									v-if="post.npp_status === 'open' && user_role === 'npp_nurse' && post.acf && post.acf.npp_assigned_nurse && post.acf.npp_assigned_nurse.ID == user"
									:aria-label="`Complete order ${post.ID}`"
									@click="updateOrderStatus(post, 'completed')"
								>
									<img :src="imageActionComplete" alt="" aria-hidden="true">
									Complete
								</button>
								<button 
									v-if="post.npp_status === 'open' && user_role === 'npp_nurse' && post.acf && post.acf.npp_assigned_nurse &&  post.acf.npp_assigned_nurse.ID == user"
									:aria-label="`Decline order ${post.ID}`"
									@click="updateOrderStatus(post, 'open')"
								>
									<img :src="imageActionDecline" alt="" aria-hidden="true">
									Decline
								</button>

							</div>
						</td>
					</tr>

					<tr v-if="post.showComments" :key="post.ID + '_comments'" :id="'comments-' + post.ID" class="order-comment-panel order-comment-panel-desktop">
						<td colspan="9">
							<div v-if="post.acf.npp_comments">
								<p><strong>Comment </strong><br />{{ post.acf.npp_comments }}</p>
							</div>
							<p><strong>Requested By:</strong> {{ post.post_author.display_name }} <strong> ID:</strong> {{ post.ID }}</p>
						</td>
					</tr>

				</template>
			</tbody>

			<tfoot>
				<tr>
					<th v-bind:aria-sort.prop="sortField === 'npp_status_date' ? sortOrder : undefined"><button @click="sortService('npp_status_date')">Status</button></th>
					<th v-bind:aria-sort.prop="sortField === 'npp_facility' ? sortOrder : undefined"><button @click="sortService('npp_facility')">Facility</button></th>
					<th v-bind:aria-sort.prop="sortField === 'npp_primary_nurse' ? sortOrder : undefined"><button @click="sortService('npp_primary_nurse')">Patient's Nurse</button></th>
					<th>Unit Phone</th>
					<th>Room #</th>
					<th v-bind:aria-sort.prop="sortField === 'npp_service' ? sortOrder : undefined"><button @click="sortService('npp_service')">Service</button></th>
					<th>Details</th>
					<th v-if="user_role === 'npp_nurse'">Assigned To</th>
					<th>Actions</th>
				</tr>
			</tfoot>
		
		</table>

		<div class="orders-not-found" v-else>
			<p>No orders found.</p>
		</div>

		<div class="orders-controls orders-controls-bottom">

			<div class="orders-pagination" id="pagination-control">
				<button 
					@click="changePage(1)"
					:disabled="currentPage == 1"
					:aria-disabled="currentPage == 1"
					aria-label="Go to first page"
				>
					<span aria-hidden="true">
						<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M9.71804 1.34422L4.56226 6.5L9.71804 11.6558" stroke="#1366F6" stroke-linecap="round"/>
						<path d="M1 1L1 12" stroke="#1366F6" stroke-linecap="round"/>
						</svg>
					</span>
				</button>
				<button 
					@click="changePage(currentPage - 1)"
					:disabled="currentPage == 1"
					:aria-disabled="currentPage == 1"
					aria-label="Go to previous page"
				>
					<span aria-hidden="true">
						<svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6.10769 1.34422L0.951904 6.5L6.10769 11.6558" stroke="#1366F6" stroke-linecap="round"/>
						</svg>
					</span>
				</button>
				<span class="orders-pagination-count" aria-live="polite"> Showing <strong>{{ startItemCount }}-{{ endItemCount }} of {{ totalItems }}</strong></span>
				<button 
					@click="changePage(currentPage + 1)"
					:disabled="currentPage == totalPages"
					:aria-disabled="currentPage == totalPages"
					aria-label="Go to next page"
				>
					<span aria-hidden="true">
						<svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M1.15574 11.6558L6.31152 6.5L1.15574 1.34422" stroke="#1366F6" stroke-linecap="round"/>
						</svg>
					</span>
				</button>
				<button 
					@click="changePage(totalPages)"
					:class="{ 'disabled': currentPage >= totalPages }"
					:disabled="currentPage == totalPages"
					:aria-disabled="currentPage == totalPages"
					aria-label="Go to last page"
				>
					<span aria-hidden="true">
						<svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M5.54539 11.6558L10.7012 6.5L5.54539 1.34422" stroke="#1366F6" stroke-linecap="round"/>
						<path d="M14.2634 12L14.2634 1" stroke="#1366F6" stroke-linecap="round"/>
						</svg>
					</span>
				</button>
			</div>
			
			<div>
				<div class="orders-per-page">
					
					<label for="orders-pagination">Results per Page:</label>
					<select id="orders-pagination" v-model="selectedPostsPerPage" @change="changePostsPerPage">
						<option v-for="option in postsPerPageOptions" :value="option">
							{{ option }}
						</option>
					</select>
				</div>
			</div>
		</div>

		<transition name="order-edit-slide">

			<form 
				class="order-edit"
				:class="[selectedPost ? 'slide-in' : '', !selectedPost ? 'slide-out' : '']" 
				v-if="selectedPost" 
				@submit.prevent="updateOrder"
				role="dialog"
				aria-modal="true"
				ref="modal"
				tabindex="0"
				aria-label="Edit Order Modal"
				@keydown.tab="trapFocus"
			>

				<button 
					ref="close"
					class="order-edit-close"
					@click="cancelUpdate"
					aria-label="Close Order Edit Modal"
				>
					<img :src="imageModalClose" alt=""  aria-hidden="true">
				</button>

				<h2 class="order-edit-title">Edit Order <span>{{ selectedPost.ID }}</span></h2>

				<div class="order-edit-field">
					<label for="facilityName">Facility</label>
					<select id="facilityName" v-model="formData.facilityName" required>
						<option v-for="facility in facilityOptions" :value="facility.value" :key="facility.value">{{ facility.name }}</option>
					</select>
				</div>

				<div class="order-edit-field">
					<label for="primaryNurse">Patient's Nurse</label>
					<input type="text" v-model="formData.primaryNurse" id="primaryNurse" required>
				</div>

				<div class="order-edit-field">
					<label for="unitPhone">Unit Phone</label>
					<input type="tel" pattern="\([0-9]{3}\) [0-9]{3}-[0-9]{4}" v-model="formData.unitPhone" id="unitPhone" required placeholder="(___) ___-____">
					<small>Format: (123) 456-7890</small><br />
				</div>
	
				<div class="order-edit-field">
					<label for="roomNumber" aria-label="Room Number">Room #</label>
					<input type="text" v-model="formData.roomNumber" id="roomNumber" required>
				</div>

				<div class="order-edit-field">
					<label for="service">Service</label>
					<select id="service" v-model="formData.service" required>
						<option v-for="option in serviceOptions" :value="option" :key="option">{{ option }}</option>
					</select>
				</div>

				<div class="order-edit-field">
					<label for="comments">Comments</label>
					<textarea v-model="formData.comments" name="comments" id="comments" rows="5"></textarea>
				</div>

				<div class="order-edit-field order-edit-footer">
					<input type="submit" value="Apply" :aria-label="`Apply changes for order ${ selectedPost.ID }`">
					<button class="order-edit-cancel" @click="cancelUpdate" :aria-label="`Cancel changes for order ${ selectedPost.ID }`">Cancel</button>
				</div>
	
			</form>
		</transition>

		<NurseModal
		:show="showModal"
		:user="selectedUser"
		@close="closeModal"
		ref="nurseModal"
		/>
	</div>
</template>

<script>

import NurseModal from './NurseModal.vue';
import axios from 'axios';
import image_action_edit from '@/images/icon-action-edit.svg';
import image_action_cancel from '@/images/icon-action-cancel.svg';
import image_action_accept from '@/images/icon-action-accept.svg';
import image_action_complete from '@/images/icon-action-complete.svg';
import image_action_decline from '@/images/icon-action-decline.svg';
import image_modal_close from '@/images/icon-modal-close.svg';


export default {
	name: 'OrdersApp',
	components: {
		NurseModal,
	},
	data() {
		return {
			showModal: false,
			imageActionEdit: image_action_edit,
			imageActionCancel: image_action_cancel,
			imageActionAccept: image_action_accept,
			imageActionComplete: image_action_complete,
			imageActionDecline: image_action_decline,
			imageModalClose: image_modal_close,
			posts: [],
			itemsPerPage: 30,
			totalItems: 0,
			currentPage: 1,
			totalPages: 0,
			statusCounts: [],
			selectedPostsPerPage: 30,
			postsPerPageOptions: [30, 60, 90],
			searchQuery: '',
			selectedFacilityTerm: '',
			selectedStatusTerm: '',
			filterByAuthor: false,
			selectedService: '',
			selectedRequester: '',
			services: [],
			facilities: [],
			requesters: [],
			sortField: 'npp_status_date',
			sortOrder: 'ascending',
			filtersChanged: false,
			selectedPost: null,
			formData: {
				facilityName: '',
				primaryNurse: '',
				unitPhone: '',
				roomNumber: '',
				service: '',
				comments: '',
			},
			serviceOptions: ['PICC', 'Midline', 'Peripheral IV', 'Declot', 'Removal', 'Port Access', 'Other'],
			facilityOptions: [],
			selectedNurse: null,
			currentAuthorId: null,
			user: null,
			user_role: null,
			site_url: null,
			stylesheet_directory: null,
			filterPanelVisible: false,
			lastFocusedElement: null,
			selectedUser: null,
		}
	},
	methods: {
		fetchPosts() {
			let currentUrl = this.site_url + '/';
			//let url = `http://nurseproplus.local/wp-json/wp/v2/npp_orders/?per_page=30&page=${this.currentPage}`;
			let orders_route = `${currentUrl}wp-json/npp/v1/orders/`;
			let orders_count_route = `${currentUrl}wp-json/npp/v1/orders-count/`;
			let url = `?per_page=${this.itemsPerPage}&page=${this.currentPage}`;
			
			if (this.searchQuery) {
				url += `&search=${this.searchQuery}`;
			}
			
			if (this.selectedFacilityTerm) {
				url += `&facility=${this.selectedFacilityTerm}`;
			}

			if (this.selectedStatusTerm) {
				url += `&status=${this.selectedStatusTerm}`;
			}

			// If the user is a nurse, filter by author
			if (this.user_role === 'npp_nurse' && ! this.selectedStatusTerm) {
				this.filterByAuthor = true;
			}

			if (this.filterByAuthor && this.currentAuthorId) {
				url += `&author=${this.currentAuthorId}`;
			}

			if (this.selectedService) {
				url += `&service=${this.selectedService}`;
			}

			if (this.selectedRequester) {
				url += `&requester=${this.selectedRequester}`;
			}

			if (this.user) {
				url += `&user=${this.user}`;
			}

			if (this.user_role) {
				url += `&user_role=${this.user_role}`;
			}

			url += `&sortField=${this.sortField}&sortOrder=${this.sortOrder}`;

			console.log(orders_route + url);

			axios.get( orders_route + url )
				.then(response => {

					// Add the showComments property to each post
					console.log(response.data);
					this.posts = response.data.map(post => {
						return {
							...post,
							showComments: false
						};
					});

					// Extract the total number of items from the response and assign it to the 'totalItems' property.
					this.totalItems = Number(response.headers['x-wp-total']);

					// Extract the total number of pages from the response and assign it to the 'totalPages' property.
					this.totalPages = Number(response.headers['x-wp-totalpages']);

					// Extract the services from the response and assign them to the 'services' property.
					this.services = [...new Set(response.data.map(post => post.npp_service))];

					// Extract and format the facilities from the response, avoiding duplicates
					const facilitySet = new Set();
					this.facilities = response.data
					.map(post => {
						if (post.acf && post.acf.npp_facility) {
						return {
							value: post.acf.npp_facility.term_id,
							name: post.acf.npp_facility.name
						};
						}
					})
					.filter(item => {
						// Exclude undefined and duplicate items
						if (item !== undefined && !facilitySet.has(item.value)) {
						facilitySet.add(item.value);
						return true;
						}
						return false;
					});

					// Extract and format the users from the response, avoiding duplicates
					const userSet = new Set();
					this.requesters = response.data.reduce((acc, post) => {
						const user = post.post_author;
						// Check if "npp_requester" role exists in the user.roles object
						if (user && user.roles && Object.values(user.roles).includes("npp_requester") && !userSet.has(user.ID)) {
							userSet.add(user.ID);
							acc.push({
								value: user.ID,
								name: user.display_name
							});
						}
						return acc;
					}, []);

				})
				.then(() => {
					// Reset the selectedPost property
					axios.get(orders_count_route + url)
						.then(response => {
							this.statusCounts = response.data;
						})
						.catch(error => {
							console.error(error);
						});
				});

				this.filtersChanged = false;
		},
		search() {
			this.currentPage = 1; // Reset to the first page for a new search
			this.fetchPosts();
		},
		filterByStatus(status) {
			this.filterByAuthor = false;
			this.selectedStatusTerm = status;
			this.search();
		},
		applyFilterByAuthor() {
			this.selectedStatusTerm = '',
			this.filterByAuthor = true;
			this.currentPage = 1; // Reset to the first page for a new search
			this.fetchPosts();
		},
		filterByService() {
			this.search();
		},
		toggleComments(index) {
			this.posts[index].showComments = !this.posts[index].showComments;
		},
		changePage(page) {
			if (page >= 1 && page <= this.totalPages) {
				this.currentPage = page;
			}
		},
		goToFirstPage() {
			this.currentPage = 1;
		},
		goToLastPage() {
			this.currentPage = this.totalPages;
		},
		changePostsPerPage() {
			this.itemsPerPage = this.selectedPostsPerPage;
			this.currentPage = 1; // reset the current page
			this.fetchPosts();
		},
		resetFilters() {
			this.searchQuery = '';
			this.selectedFacilityTerm = '';
			this.selectedStatusTerm = '';
			this.filterByAuthor = false;
			this.selectedService = '';
			this.selectedRequester = '';
			this.currentPage = 1;  // reset to the first page
			this.fetchPosts();  // fetch the posts again with the updated filters
		},
		sortService(sortField) {
			this.sortField = sortField;
			this.sortOrder = this.sortOrder === 'ascending' ? 'descending' : 'ascending';
			this.fetchPosts();
		},
		updateOrderStatus(post, status) {
			
			let previousStatus = post.npp_status;
			let message = '';
			if(status === 'canceled' ) {
				message = "Are you sure you want to cancel this order? Canceled orders cannot be reopened.";
			} else if(status === 'completed' ) {
				message = "Are you sure you want to mark this order complete? Completed orders cannot be reopened.";
			} else if ( status === 'open' ) {
				message = "Declining an order will remove you from the order and open it up so another nurse can fulfill it.";
			}

			if ( window.confirm( message ) ) {
				
				// API call to update the order's status on the server.
				axios.post('wp-json/npp/v1/updateOrderStatus', {
					orderId: post.ID,
					newStatus: status,
					currentUserID: this.user,
				}, {
					headers: {
						'X-WP-Nonce': npp_vars._wpnonce,
					},
					//withCredentials: true,
				})
				.then(response => {
					console.log(response);

					// Update the status date.
					post.npp_status_date = response.data.npp_status_date;

					// Change the status of the post.
					post.npp_status = status;

					// If the order was cancelled, remove the assigned nurse.
					if( status === 'open') {
						post.acf.npp_assigned_nurse = '';
					}

					// update the status counts
					if( previousStatus !== status ) {
						this.statusCounts[previousStatus] -= 1;
						this.statusCounts[status] += 1;
					}

					// update the 'mine' status count
					if( status === 'open' || ( status === 'completed' && previousStatus === 'open' ) ) {
						this.statusCounts['mine'] -= 1;
					}
				})
				.catch(error => {
					console.error(error);
				});
			}
		},
		assignNurse(post) {
			if (window.confirm('Are you sure you want to accept this order?')) {
				axios.post('wp-json/npp/v1/assignNurse', {
					orderId: post.ID,
					nurseId: this.user,
				}, {
					headers: {
						'X-WP-Nonce': npp_vars._wpnonce,
					},
					//withCredentials: true,
				})
				.then(response => {
					console.log(response);

					// Check if the assignment is successful.
					if(response.data.success) {
						// Find the index of the post in the posts array.
						let index = this.posts.findIndex(p => p.ID === post.ID);
						
						// Check if the post is found.
						if (index !== -1) {
							// Update the post with the returned post object.
							this.posts[index] = response.data.post;
							console.log(this.posts[index]);
						}

						// Increment the count for the 'mine' status in the statusCounts array.
						if (this.statusCounts['mine'] !== undefined) {
							this.statusCounts['mine'] += 1;
						} else {
							// If 'mine' status does not exist in the statusCounts array, initialize it with 1.
							this.$set(this.statusCounts, 'mine', 1);
						}
					} else {
						// Log the error message.
						console.error(response.data.message);
					}
				})
				.catch(error => {
					console.error(error);
					alert(error.response.data.message);

					if (error.response.data.post) {
						// Find the index of the post in the posts array.
						let index = this.posts.findIndex(p => p.ID === post.ID);
						
						// Check if the post is found.
						if (index !== -1) {
							// Update the post with the returned post object.
							this.posts[index] = error.response.data.post;
						}
					}
				});
			}
		},
		openForm(post) {

			// set last focused element
			this.lastFocusedElement = document.activeElement;

			this.toggleBodyScroll(false);
			
			this.selectedPost = post;
			console.log(this.selectedPost);
			
			if (post.acf) {
				this.formData = {
					facilityName: post.acf.npp_facility.term_id,
					primaryNurse: post.acf.npp_primary_nurse || '',
					unitPhone: post.acf.npp_unit_phone || '',
					roomNumber: post.acf.npp_room_number || '',
					service: post.acf.npp_service || '',
					comments: post.acf.npp_comments || ''
				}; 
			} else {
				this.formData = {
					facilityName: '',
					primaryNurse: '',
					unitPhone: '',
					roomNumber: '',
					service: '',
					comments: ''
				};
			}

			// set focus to close button
			this.$nextTick(() => {
                if (this.$refs.close) {
                    this.$refs.close.focus();
                } else {
                    console.warn('Element with ref="close" not found');
                }
            });
			
		},
		toggleBodyScroll(enable) {
			document.body.style.overflow = enable ? 'auto' : 'hidden';
		},
		updateOrder() {
			axios.post('wp-json/npp/v1/updateOrder', {
				postId: this.selectedPost.ID,
				formData: this.formData,
				currentUserID: this.user,
			}, {
				headers: {
					'X-WP-Nonce': npp_vars._wpnonce,
				},
				//withCredentials: true,
			})
			.then(response => {

				// The server should return the updated post data in the response.
				let updatedPost = response.data;

				// Find the index of the post in the 'posts' array.
				let postIndex = this.posts.findIndex(post => post.ID === this.selectedPost.ID);

				// Replace the old post with the updated one.
				//this.$set(this.posts, postIndex, updatedPost);

				// Check if postIndex is valid and updatedPost.acf is defined.
				if (postIndex >= 0 && updatedPost.acf) {
					// Only replace the 'acf' field of the post with the updated 'acf'.
					this.posts[postIndex].acf = updatedPost.acf;
				} else {
					console.warn('Post index not found or updatedPost.acf is undefined');
				}
				
				this.formData = {
					facilityName: '',
					primaryNurse: '',
					unitPhone: '',
					roomNumber: '',
					service: '',
					comments: ''
				};
				this.selectedPost = null;

				if (this.lastFocusedElement) {
                	this.lastFocusedElement.focus(); // Focus on the element that opened the modal
            	}

				this.toggleBodyScroll(true);
			})
			.catch(error => {
				console.error(error);
			});
			
		},
		cancelUpdate( event ) {
			this.toggleBodyScroll(true);
			event.preventDefault();
			this.selectedPost = null;
			if (this.lastFocusedElement) {
                this.lastFocusedElement.focus(); // Focus on the element that opened the modal
            }
		},
		openModal(user, shifts, index) {
			this.selectedUser = user;
			this.showModal = true;
			this.openButtonIndex = index;

			this.$nextTick(() => {
				this.$refs.nurseModal.$refs.nurseModalClose.focus();
			});
		},
		closeModal() {
			this.showModal = false;

			this.$nextTick(() => {
				this.$refs[`nurseModalOpenButton-${this.openButtonIndex}`][0].focus();
			});
		},
		toggleFilterPanel() {
			this.filterPanelVisible = !this.filterPanelVisible;
			this.lastFocusedElement = document.activeElement;
			this.$nextTick(() => {
                if (this.$refs.close) {
                    this.$refs.close.focus();
                } else {
                    console.warn('Element with ref="close" not found');
                }
            });
		},
		closeFilterPanel() {
			this.filterPanelVisible = false;
			if (this.lastFocusedElement) {
                this.lastFocusedElement.focus(); // Focus on the element that opened the modal
            }
		},
		trapFocus(event) {
            if (this.filterPanelVisible || this.selectedPost) {
                const focusableElements = this.$refs.modal.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );
                const firstFocusableEl = focusableElements[0];
                const lastFocusableEl = focusableElements[focusableElements.length - 1];

                if (event.shiftKey) {
                    if (document.activeElement === firstFocusableEl) {
                        event.preventDefault();
                        lastFocusableEl.focus();
                    }
                } else {
                    if (document.activeElement === lastFocusableEl) {
                        event.preventDefault();
                        firstFocusableEl.focus();
                    }
                }
            }
        },
	},
	watch: {
		currentPage() {
			this.fetchPosts();
		},
		searchQuery: function() {
			this.filtersChanged = true;
		},
		selectedFacilityTerm: function() {
			this.filtersChanged = true;
		},
		selectedStatusTerm: function() {
			this.filtersChanged = true;
		},
		filterByAuthor: function() {
			this.filtersChanged = true;
		},
		selectedService: function() {
			this.filtersChanged = true;
		},
		selectedRequester: function() {
			this.filtersChanged = true;
		},
		sortField: function() {
			this.filtersChanged = true;
		},
		sortOrder: function() {
			this.filtersChanged = true;
		},
	},
	created() {
		//this.fetchPosts();
	},
	computed: {
		startItemCount() {
			return this.totalItems > 0 ? (this.currentPage - 1) * this.itemsPerPage + 1 : 0;
		},
		endItemCount() {
			return Math.min(this.startItemCount + this.itemsPerPage - 1, this.totalItems);
		},
	},
	mounted() {
		console.log(npp_vars);
		this.currentAuthorId = npp_vars.current_user_id;
		this.user = npp_vars.current_user_id;
		this.user_role = npp_vars.current_user_role;
		this.site_url = npp_vars.site_url;
		this.stylesheet_directory = npp_vars.stylesheet_directory;

		console.log('current user id: ' + this.currentAuthorId);

		axios.get('wp-json/npp/v1/connectedFacilities/' + this.user)
		.then(response => {
			this.facilityOptions = response.data;
		})
		.catch(error => {
			console.error(error);
		});

		this.fetchPosts();
	}
};
</script>

<style scoped>
	/* Your CSS goes here */
</style>
